import React, { Component } from 'react';
//components

//styles
import './scss/app.scss';
import '../../Static/fonts/opensanshebrew/stylesheet.css'
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Main from '../Main/Main';

class App extends Component {
  render() {
    return (
      <div>
        <Header />
        <Main />
        <Footer />
     </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js